import React from "react";

import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import ComponentErrorBoundary from "@/components/shared/business/ComponentErrorBoundary/ComponentErrorBoundary";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import DefaultDrugProfileGroupTable from "@FillInTableContainer/shared/components/DefaultDrugProfileGroupTable/DefaultDrugProfileGroupTable";
import TableCreatorNavigationTableWrapper from "@FillInTableContainer/shared/components/TableCreatorNavigationTableWrapper/TableCreatorNavigationTableWrapper";

const ConferenceScheduleTableCreator = () => {
  const errorWithComponent = (title: string) => (
    <TableCreatorGroupTableTitle title={title} isRequired={false} />
  );

  return (
    <TableCreatorNavigationTableWrapper
      classificationKey={ENTRY_DATA_SECTION_KEYS.conferenceSchedule}
    >
      <>
        <ComponentErrorBoundary
          addComponents={errorWithComponent("Drug Profile")}
        >
          <DefaultDrugProfileGroupTable />
        </ComponentErrorBoundary>
      </>
    </TableCreatorNavigationTableWrapper>
  );
};

export default ConferenceScheduleTableCreator;
